// Generated from the approved MagicPath revision 440847621280641024. Do not hand-edit; update the source worktree instead.
import { useState } from 'react';

const navigation = ['METHOD', 'HOUSE 45', 'INSIGHTS', 'ASSESSMENT'];
const traits = ['COMPETITIVENESS', 'INTENSITY', 'APPETITE FOR RISK', 'OBSESSION', 'CONFIDENCE', 'AGGRESSION', 'PATTERN RECOGNITION', 'DESIRE FOR STAKES'];

export const Page02YourEngine = () => {
  const [activeTrait, setActiveTrait] = useState('COMPETITIVENESS');
  const [activeNav, setActiveNav] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);

  return <main className="note-page">
    <img className="note-background" src="/assets/page02c-note.png" alt="A dark river cutting through black rock beneath storm clouds" />

    <div className="note-frame">
      <header className="note-header">
        <button className="note-wordmark" type="button" aria-label="IMTHEHOUSE home" onClick={() => setActiveNav('')}>IMTHEHOUSE</button>

        <nav className="note-navigation" aria-label="Primary navigation">
          {navigation.map(item => <button key={item} type="button" className={activeNav === item ? 'active' : ''} aria-pressed={activeNav === item} onClick={() => setActiveNav(item)}>{item}</button>)}
        </nav>

        <button className="note-menu" type="button" aria-label="Toggle navigation" aria-expanded={menuOpen} onClick={() => setMenuOpen(open => !open)}>
          <span />
          <span />
        </button>

        {menuOpen && <nav className="note-mobile-navigation" aria-label="Mobile navigation">
          {navigation.map(item => <button key={item} type="button" className={activeNav === item ? 'active' : ''} onClick={() => {
            setActiveNav(item);
            setMenuOpen(false);
          }}>{item}</button>)}
        </nav>}
      </header>

      <section className="note-content" aria-labelledby="note-title">
        <div className="note-identity">
          <p className="note-eyebrow">YOUR ENGINE</p>
          <h1 id="note-title">
            YOU HAVE AN<br />
            EXTREMELY POWERFUL<br />
            PSYCHOLOGICAL ENGINE.
          </h1>
        </div>

        <article className="note-letter" aria-labelledby="note-letter-heading">
          <p className="note-letter-label" id="note-letter-heading">A NOTE FROM US</p>
          <p>
            <strong>We don&rsquo;t think you gamble like this because you&rsquo;re weak.</strong>{' '}
            We think the opposite. The game found the parts of you that do not quit&mdash;the
            part that hates losing, trusts the read, presses when other men pull back, and
            comes alive when consequence is real.
          </p>
          <p>
            The sportsbook knows exactly what to do with that wiring. It feeds your
            competitiveness a loss to answer. It feeds your pattern recognition noise until
            it looks like signal. It gives your confidence another reason to trust the next
            bet and your appetite for risk a door that never closes. That is the business.
          </p>
          <p>
            We are not here to strip those traits out of you. They are useful. They are yours.
            We are here to stop a machine from deciding where they go. Keep the engine. Change
            who commands it.
          </p>
        </article>
      </section>

      <nav className="note-traits" aria-label="Psychological capacities">
        {traits.map(trait => <button key={trait} type="button" className={activeTrait === trait ? 'active' : ''} aria-pressed={activeTrait === trait} onClick={() => setActiveTrait(trait)} onMouseEnter={() => setActiveTrait(trait)} onFocus={() => setActiveTrait(trait)}>{trait}</button>)}
      </nav>
    </div>
  </main>;
};
